import React, { useRef, useState } from 'react';
import { BookingBottomNavbar } from 'Components/widgets/booking-bottom-navbar/BookingBottomNavbar';
import { useAppContext } from 'Context/ReactAppContext';
import { t } from 'Src/i18n';
import { BookingNavbarProvider } from 'Components/widgets/booking-navbar/BookingNavbarContext';
import { getTotalPriceWithDonation } from 'Components/utils/price/price.util';
export const BookingLayout = ({
  selectedProposal,
  currentPage,
  previousPage,
  nextPage,
  price,
  goToNextStep,
  i18n,
  resort,
  isFavorite,
  isOptionHoldOnly,
  previousAction,
  isOnLastPage,
  shouldOpenPanel,
  closePanel,
  onClickFavorite,
  isNextStep,
  children,
}: any) => {
  const appContext = useAppContext();
  const navbarRef = useRef();
  const [hideContinueButton, setHideContinueButton] = useState(false);
  const [isPriceLoading, setIsPriceLoading] = useState(false);
  const [noEdit, setNoEdit] = useState(true);
  const [overwriteContinueButton, setOverwriteContinueButton] = useState(false);
  const [continueBtn, setContinueBtn] = useState(null);
  const [portalPosition, setPortalPosition] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [priceShouldIncludeDonation, setPriceShouldIncludeDonation] = useState(true);
  const [validationCallback, setValidationCallback] = useState(null);
  const [paymentLabel, setPaymentLabel] = useState();
  const { withDonation } = getTotalPriceWithDonation(price, appContext.locale);
  return (
    <BookingNavbarProvider
      currentPage={currentPage}
      hideContinueButton={hideContinueButton}
      setHideContinueButton={setHideContinueButton}
      setIsPriceLoading={setIsPriceLoading}
      setPriceShouldIncludeDonation={setPriceShouldIncludeDonation}
      navbarRef={navbarRef}
      setNoEdit={setNoEdit}
      setContinueBtn={setContinueBtn}
      setOverwriteContinueButton={setOverwriteContinueButton}
      setPortalPosition={setPortalPosition}
      setIsDisabled={setIsDisabled}
      setValidationCallback={setValidationCallback}
      setPaymentLabel={setPaymentLabel}
    >
      {children}
      <BookingBottomNavbar
        continueBtn={continueBtn}
        overwriteContinueButton={overwriteContinueButton}
        i18n={i18n}
        previousAction={previousAction}
        price={priceShouldIncludeDonation ? withDonation : price}
        proposal={selectedProposal}
        resort={resort}
        currentPage={currentPage}
        portalPosition={portalPosition}
        previousPage={previousPage}
        nextPage={nextPage}
        paymentLabel={paymentLabel || t('booking.priceDetails.packagePrice.bookingLabel')}
        noEdit={noEdit}
        isOnLastPage={isOnLastPage}
        hideContinueButton={hideContinueButton}
        isDisabled={!!isDisabled}
        isPriceLoading={isPriceLoading}
        continueAction={goToNextStep(validationCallback)}
        shouldOpenPanel={shouldOpenPanel}
        closePanel={closePanel}
        isOptionHoldOnly={isOptionHoldOnly}
        navbarRef={navbarRef}
        onClickFavorite={onClickFavorite}
        isFavorite={isFavorite}
        isNextStep={isNextStep}
      />
    </BookingNavbarProvider>
  );
};
